export const doughnutPersonalCareOptions = {
  title: {
    text: "Personal care",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },

  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 426,
        },
        chartOptions: {
          series: [
            {
              size: "70%",
            },
          ],
        },
      },
    ],
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  legend: {
    layout: "horizontal",
    align: "center",
    x: 0,
    y: 375,
    floating: true,
    itemStyle: {
      color: "#092f50",
      fontWeight: 500,
      fontSize: "14px",
    },
    verticalAlign: "center",
    itemMarginTop: 5,
    itemMarginBottom: 0,
    itemDistance: 5,
    useHTML: true,
    labelFormatter: function () {
      var legendItem = document.createElement("div"),
        dot = document.createElement("span"),
        label = document.createElement("span");

      dot.style.backgroundColor = this.color;
      dot.style.width = "10px"; // Adjust the dot size as needed
      dot.style.height = "10px";
      dot.style.display = "inline-block";
      dot.style.borderRadius = "100%";
      dot.style.marginRight = "5px"; // Adjust the spacing between the dot and label

      label.innerText = this.test;
      legendItem.appendChild(dot);
      legendItem.appendChild(label);

      return legendItem.outerHTML;
    },
  },

  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      showInLegend: true,
      dataLabels: {
        enabled: false,
      },
      stickyTracking: false,
      data: [
        {
          test: "Personal Care",
          y: 16,
          color: "rgba(9, 47, 80, 1)",
        },
        {
          test: "Baby Care",
          y: 7,
          color: "rgba(76, 97, 114, 1)",
        },
        {
          test: "Healthcare & Medicines",
          y: 20,
          color: "rgba(255, 230, 80, 1)",
        },
        {
          test: "Household & Laundry",
          y: 19,
          color: "rgba(37, 129, 196, 1)",
        },
        {
          test: "Pet Food",
          y: 38,
          color: "rgba(34, 174, 147, 1)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
           <strong>${this.y}%</strong> <br />
            (${this.test})
            `;
          return output;
        },
      },
    },
  ],
};

export const doughnutPersonalCareMarket = {
  title: {
    text: "Toiletries",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 426,
        },
        chartOptions: {
          series: [
            {
              size: "70%",
            },
          ],
        },
      },
    ],
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  legend: {
    layout: "horizontal",
    align: "center",
    x: 0,
    y: 375,
    floating: true,
    itemStyle: {
      color: "#092f50",
      fontWeight: 500,
      fontSize: "14px",
    },
    verticalAlign: "center",
    itemMarginTop: 5,
    itemMarginBottom: 0,
    itemDistance: 5,
    useHTML: true,
    labelFormatter: function () {
      var legendItem = document.createElement("div"),
        dot = document.createElement("span"),
        label = document.createElement("span");

      dot.style.backgroundColor = this.color;
      dot.style.width = "10px";
      dot.style.height = "10px";
      dot.style.display = "inline-block";
      dot.style.borderRadius = "100%";
      dot.style.marginRight = "5px";

      label.innerText = this.test;
      legendItem.appendChild(dot);
      legendItem.appendChild(label);

      return legendItem.outerHTML;
    },
  },

  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
      stickyTracking: false,
      data: [
        {
          test: "Personal Care",
          y: 32,
          color: "rgba(9, 47, 80, 1)",
        },
        {
          test: "Baby Care",
          y: 9,
          color: "rgba(76, 97, 114, 1)",
        },
        {
          test: "Healthcare & Medicines",
          y: 15,
          color: "rgba(255, 230, 0, 1)",
        },
        {
          test: "Household & Laundry",
          y: 24,
          color: "rgba(37, 129, 196, 1)",
        },
        {
          test: "Pet Food",
          y: 20,
          color: "rgba(34, 174, 147, 1)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
             <strong>${this.y}%</strong> <br />
              (${this.test})
              `;
          return output;
        },
      },
    },
  ],
};

export const doughnutBabyCareOptions = {
  title: {
    text: "Baby Care",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
      stickyTracking: false,
      data: [
        {
          test: "Baby Food",
          y: 8,
          color: "rgb(9, 47, 80)",
        },
        {
          test: "Baby Milk",
          y: 36,
          color: "rgb(255, 230, 0)",
        },
        {
          test: "Nappies",
          y: 20,
          color: "rgb(76, 97, 114)",
        },
        {
          test: "Toiletries",
          y: 7,
          color: "rgb(37, 129, 196, 1)",
        },
        {
          test: "Wipes",
          y: 29,
          color: "rgb(37, 129, 196, 0.5)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
           <strong>${this.y}%</strong> <br />
            (${this.test})
            `;
          return output;
        },
      },
    },
  ],
};

export const doughnutBabyCareMarket = {
  title: {
    text: "Baby Care",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
      stickyTracking: false,
      data: [
        {
          test: "Baby Food",
          y: 15,
          color: "rgb(9, 47, 80)",
        },
        {
          test: "Baby Milk",
          y: 28,
          color: "rgb(255, 230, 0)",
        },
        {
          test: "Nappies",
          y: 32,
          color: "rgb(76, 97, 114)",
        },
        {
          test: "Toiletries",
          y: 9,
          color: "rgb(37, 129, 196, 1)",
        },
        {
          test: "Wipes",
          y: 16,
          color: "rgb(37, 129, 196, 0.5)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
             <strong>${this.y}%</strong> <br />
              (${this.test}m)
              `;
          return output;
        },
      },
    },
  ],
};

export const doughnutMedicinesOptions = {
  title: {
    text: "Medicines",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
      stickyTracking: false,
      data: [
        {
          test: "Adult Pain",
          y: 38,
          color: "rgb(9, 47, 80, 1)",
        },
        {
          test: "Allergy & Hayfever",
          y: 4,
          color: "rgb(9, 47, 80, 0.9)",
        },
        {
          test: "Children's Medicines",
          y: 11,
          color: "rgb(255, 230, 0, 1)",
        },
        {
          test: "Cough, Cold & Flu",
          y: 25,
          color: "rgb(255, 230, 0, 0.5)",
        },
        {
          test: "Digestive Health",
          y: 13,
          color: "rgb(76, 97, 114, 1)",
        },
        {
          test: "First Aid",
          y: 3,
          color: "rgb(76, 97, 114, 0.7)",
        },
        {
          test: "NRT",
          y: 0.1,
          color: "rgb(76, 97, 114, 0.4)",
        },
        {
          test: "Sexual Wellbeing",
          y: 5,
          color: "rgba(37, 129, 196, 1)",
        },
        {
          test: "Skin Health",
          y: 1,
          color: "rgba(37, 129, 196, 0.7)",
        },
        {
          test: "Sleep Aids",
          y: 0.2,
          color: "rgba(37, 129, 196, 0.4)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
           <strong>${this.y}%</strong> <br />
            (${this.test})
            `;
          return output;
        },
      },
    },
  ],
};

export const doughnutMedicinesMarket = {
  title: {
    text: "Medicines",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },

      stickyTracking: false,
      data: [
        {
          test: "Adult Pain",
          y: 19,
          color: "rgb(9, 47, 80, 1)",
        },
        {
          test: "Allergy & Hayfever",
          y: 6,
          color: "rgb(9, 47, 80, 0.9)",
        },
        {
          test: "Children's Medicines",
          y: 7,
          color: "rgb(255, 230, 0, 1)",
        },
        {
          test: "Cough, Cold & Flu",
          y: 18,
          color: "rgb(255, 230, 0, 0.5)",
        },
        {
          test: "Digestive Health",
          y: 15,
          color: "rgb(76, 97, 114, 1)",
        },
        {
          test: "First Aid",
          y: 4,
          color: "rgb(76, 97, 114, 0.7)",
        },
        {
          test: "NRT",
          y: 6,
          color: "rgb(76, 97, 114, 0.4)",
        },
        {
          test: "Sexual Wellbeing",
          y: 8,
          color: "rgba(37, 129, 196, 1)",
        },
        {
          test: "Skin Health",
          y: 15,
          color: "rgba(37, 129, 196, 0.7)",
        },
        {
          test: "Sleep Aids",
          y: 2,
          color: "rgba(37, 129, 196, 0.4)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
             <strong>${this.y}%</strong> <br />
              (${this.test}m)
              `;
          return output;
        },
      },
    },
  ],
};

export const doughnutHouseHoldsOptions = {
  title: {
    text: "Households",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
      stickyTracking: false,
      data: [
        {
          test: "Air Care",
          y: 6,
          color: "rgb(9, 47, 80, 1)",
        },
        {
          test: "Bleach & Toilet",
          y: 9,
          color: "rgb(9, 47, 80, 0.7)",
        },
        {
          test: "Dish Care",
          y: 18,
          color: "rgb(9, 47, 80, 0.4)",
        },
        {
          test: "Fabric Enhancers",
          y: 14,
          color: "rgb(255, 230, 0, 1)",
        },
        {
          test: "Household Cleaning",
          y: 9,
          color: "rgb(255, 230, 0, 0.5)",
        },
        {
          test: "Laundry",
          y: 35,
          color: "rgb(37, 129, 196, 1)",
        },
        {
          test: "Specialist Cleaning",
          y: 9,
          color: "rgb(37, 129, 196, 0.7)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
           <strong>${this.y}%</strong> <br />
            (${this.test}m)
            `;
          return output;
        },
      },
    },
  ],
};

export const doughnutHouseHoldsMarket = {
  title: {
    text: "Households",
    align: "left",
    x: 0,
    y: 10,
  },
  tooltip: {
    hideDelay: 0,
    useHTML: true,
  },
  chart: {
    backgroundColor: "#E7E8ED",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      shadow: false,
      center: ["50%", "50%"],
      borderWidth: 0,
    },
  },
  series: [
    {
      type: "pie",
      size: "80%",
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
      stickyTracking: false,
      data: [
        {
          test: "Air Care",
          y: 8,
          color: "rgb(9, 47, 80, 1)",
        },
        {
          test: "Bleach & Toilet",
          y: 8,
          color: "rgb(9, 47, 80, 0.7)",
        },
        {
          test: "Dish Care",
          y: 15,
          color: "rgb(9, 47, 80, 0.4)",
        },
        {
          test: "Fabric Enhancers",
          y: 15,
          color: "rgb(255, 230, 0, 1)",
        },
        {
          test: "Household Cleaning",
          y: 11,
          color: "rgb(255, 230, 0, 0.5)",
        },
        {
          test: "Laundry",
          y: 36,
          color: "rgb(37, 129, 196, 1)",
        },
        {
          test: "Specialist Cleaning",
          y: 7,
          color: "rgb(37, 129, 196, 0.7)",
        },
      ],
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const output = `
             <strong>${this.y}%</strong> <br />
              (${this.test}m)
              `;
          return output;
        },
      },
    },
  ],
};
